<div class="login_page">
    <div class="login_box">
        <div class="switch_language">
            <select @change="switchLanguage" v-model="selectLanguage">
                <option value="zh-CN" :checked="selectLanguage === 'zh-CN' ?'checked' : ''">{{ $t('zh') }}</option>
                <option value="en-US" :checked="selectLanguage === 'en-US' ?'checked' : ''">{{ $t('en') }}</option>
            </select>
        </div>
        <div class="password"><input v-model="password" :placeholder="$t('enterPassword')" class="pwd" type="password" @keyup.enter="login"></div>
        <button class="mdc-button mdc-button--raised" @click="login">
            {{ $t('confirm') }}
        </button>
    </div>
</div>
<show-message :messageContent="messageContent" />